// @flow

import { Button } from "react-bootstrap";
import { map } from "lodash";
import * as React from "react";

import { for_display } from "utils/str_utils";
import { get_feature_attr, get_option_image_url } from "models/catalogue";
import type { Feature, Option } from "types";

type Props = {
  feature: Feature,
  options: Array<Option>,
  selectedOption: string,
  onSelect: (string, string) => void
};

const OptionSelector = ({
  feature,
  options,
  selectedOption,
  onSelect
}: Props) => {
  const option_selector = (
    <>
      {map(options, option => {
        const image_url = get_option_image_url(option);
        let imageContent = image_url ? (
          <img
            alt={image_url}
            src={`https://happymoose-blog-post-images.imgix.net/${image_url}?w=100&h=100&auto=format`}
          />
        ) : (
          ""
        );

        let buttonContent = (
          <>
            {imageContent}
            <span className={"option_name"}>{for_display(option)}</span>
          </>
        );

        return (
          <Button
            key={option}
            className={`btn selector--btn-choice option-${option} ${
              image_url ? "btn-image" : ""
            } btn-${selectedOption === option ? "primary" : ""}`}
            onClick={() => onSelect(selectedOption, option)}>
            {buttonContent}
          </Button>
        );
      })}
    </>
  );

  return (
    <div className={`selector option-selector feature-${feature}`}>
      <div className="selector--header">
        <h3>
          Select {for_display(feature)}
          <a
            className={"option-selector--learn-more"}
            href="#"
            data-beacon-article={get_feature_attr(feature, "_beacon-article")}>
            Learn more
          </a>
        </h3>
      </div>
      <div className="selector">
        <div className="selector-wrapper">{option_selector}</div>
      </div>
    </div>
  );
};

export default OptionSelector;
